export const isStatelessComponent = (Component) => !(Component.prototype && Component.prototype.render);
//# sourceMappingURL=utils.js.map